import { Drawing } from "./Drawing";
import { State } from "../redux/State";
import { Map } from "immutable";

import { Id_building, Id_drawing, Id_floor } from "../api/Identifiers";
import { cms_logging } from "../cms_logging";
import { exists } from "../utils";
import { FloorsCollection, Floor } from "../Floor";

export function temp_get_drawing_from_id_drawing(id_drawing: string, imm_state: Map<any, any>): any {
    let d: Drawing = State.wrap(imm_state).all_drawings.get_drawing_from_drawing_id(Id_drawing.wrap(id_drawing));
    if (d === null) {
        return null;
    }
    return d.toJSON();
}

export class DrawingsCollection {

    public static get empty(): DrawingsCollection {
        return DrawingsCollection.build_from_raw([]);
    }
    private _drawings_temp_list: Drawing[] = null;
    private _drawings: any = [];
    private _drawing_location_map: any = {};
    public get drawing_location_map(): any {
        return this._drawing_location_map;
    }

    public get floors(): FloorsCollection {
        let r: FloorsCollection = FloorsCollection.empty();
        this.drawings.forEach((drawing: Drawing) => {
            r.add(Floor.build(drawing.id_floor,
                drawing.location_description,
                drawing.z_index));
        });
        return r;

    }
    public get drawings(): Drawing[] {
        if (this._drawings_temp_list === null) {
            this._drawings_temp_list = [];
            Object.keys(this._drawings).forEach((key: string) => {
                let drawing: Drawing = this._drawings[key];
                this._drawings_temp_list.push(drawing);
            });
        }
        return this._drawings_temp_list;
    }

    public get displayable_drawings(): DrawingsCollection {
        let r: DrawingsCollection = DrawingsCollection.empty;
        Object.keys(this._drawings).forEach((key: string) => {
            let drawing: Drawing = this._drawings[key];
            if (drawing.is_dispalyable) {
                r.add(drawing);
            }
        });
        return r;
    }

    public toJSON(): any {
        return JSON.parse(JSON.stringify(this.drawings));
    }

    public has_building(id_building: Id_building): boolean {
        this.drawings.forEach((drawing: Drawing) => {
            if (drawing.id_building.equals(id_building)) {
                return true;
            }
        });
        return false;
    }

    public has_drawing(id_drawing: Id_drawing): boolean {
        this.drawings.forEach((drawing: Drawing) => {
            if (drawing.id.equals(id_drawing)) {
                return true;
            }
        });
        return false;
    }

    public has_floor(id_floor: Id_floor): boolean {
        this.drawings.forEach((drawing: Drawing) => {
            if (drawing.id_floor.equals(id_floor)) {
                return true;
            }

        });
        return false;
    }
    public get_drawing_from_drawing_id(id_drawing: Id_drawing): Drawing {
        let d: Drawing[] = this.drawings.filter((drawing: Drawing) => {
            return drawing.id.equals(id_drawing);
        });
        if (d.length > 0) {
            return d[0];
        }
        console.debug(`could not find drawing  ${id_drawing}`);
        return null;  // not found    
    }

    public get_all_in_building(id_building: Id_building): DrawingsCollection {
        let r: DrawingsCollection = new DrawingsCollection();

        this.drawings.forEach((drawing: Drawing) => {
            if (drawing.id_building.equals(id_building)) {
                r.add(drawing);
            }
        });
        return r;
    }

    public get_all_in_floor(id_floor: Id_floor): DrawingsCollection {
        let _drawings: DrawingsCollection = new DrawingsCollection();
        this.drawings.forEach((drawing: Drawing) => {
            if (drawing.id_floor.equals(id_floor)) {
                _drawings.add(drawing);
            }
        });
        return _drawings;
    }

    public get_a_drawing_for_the_first_floor_in_building(id_building: Id_building): Drawing{
        let drawing : Drawing = null;
        let dc : DrawingsCollection = this.get_all_in_building(id_building);
        if (exists(dc)){
            let floor : Floor = dc.floors.floors[0];
            if (exists(floor)){
                let drawings: Drawing[] = this.get_all_in_floor(floor.id).drawings;
                if (drawings.length > 0){
                    drawing = drawings[0];
                }
            }

        }
        
        return drawing;
    }

    public get length(): number {
        return this.drawings.length;
    }

    public static build_from_clean(clean_drawings: any[]): DrawingsCollection {
        let r: DrawingsCollection = new DrawingsCollection();
        if (clean_drawings !== null) {
            clean_drawings.forEach(clean_drawing => {
                r.add(Drawing.build_from_clean(clean_drawing));
            });
        }
        return r;
    }

    public static build_from_raw(raw_drawings: any[]): DrawingsCollection {
        let r: DrawingsCollection = new DrawingsCollection();
        if (raw_drawings) {
            raw_drawings.forEach(raw_drawing => {
                r.add(Drawing.build_from_raw(raw_drawing));
            });
        }
        else {
            cms_logging.error("null or undefined raw_drawings were sent to DrawingsCollection.build_from_raw()");
        }
        return r;
    }

    public static build_from_raw_sitemap(raw_drawings: any[]): DrawingsCollection {
        let r: DrawingsCollection = new DrawingsCollection();
        if (raw_drawings !== null) {
            raw_drawings.forEach(raw_drawing => {
                r.add(Drawing.build_from_raw_sitemap(raw_drawing));
            });
        }
        return r;
    }

    public add(drawing: Drawing): void {
        if (drawing) {
            this._drawings_temp_list = null;
            this._drawings[drawing.id.value] = drawing;
            this._drawing_location_map[drawing.id_floor.value] = drawing.id.value;  // awh this will go away
            this._drawing_location_map[drawing.id.value] = drawing.id_floor.value;  // awh this will go away
        }
    }
    public add_collection(drawings: DrawingsCollection): void {
        if (drawings) {
            drawings.drawings.forEach((drawing: Drawing) => { this.add(drawing); });
        }
    }
}
